export function fileIsImageFile(file: File | undefined | null): boolean {
  // TODO the file.type is autodetected from extension. We should Replace with magic word byte checking to be completely safe.
  // We can use file-type package which provides this functionality for us if we don't want to implement this ourselves.
  // https://github.com/sindresorhus/file-type
  return file?.type.startsWith('image/') ?? false;
}
